export const getIssueTypesSettingsUrl = (projectKey: string, isSimplified: boolean) =>
	isSimplified
		? `/jira/core/projects/${projectKey}/settings/issuetypes`
		: `/plugins/servlet/project-config/${projectKey}/issuetypes`;
